import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Button from "../../../../components/Button/Button";
import { updateSceneSchedule, startSceneSchedule, endSceneSchedule } from "../../../../services/apis/StudioApi";

const SceneScheduleCard = ({ scene, schedule: initialSchedule, onUpdate }) => {
    // start_at and end_at can be strings or null.
    const [startAt, setStartAt] = useState(initialSchedule?.start_at ? new Date(initialSchedule.start_at) : null);
    const [endAt, setEndAt] = useState(initialSchedule?.end_at ? new Date(initialSchedule.end_at) : null);
    const [isLoading, setIsLoading] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false); // Default collapsed

    // Update local state when prop changes
    useEffect(() => {
        setStartAt(initialSchedule?.start_at ? new Date(initialSchedule.start_at) : null);
        setEndAt(initialSchedule?.end_at ? new Date(initialSchedule.end_at) : null);
    }, [initialSchedule]);

    const handleSave = async () => {
        setIsLoading(true);
        try {
            const data = {
                start_at: startAt ? startAt.toISOString() : null,
                end_at: endAt ? endAt.toISOString() : null,
            };
            const response = await updateSceneSchedule(scene.id, data);
            if (response.status === 200) {
                onUpdate(response.data);
                alert("일정이 저장되었습니다.");
            }
        } catch (error) {
            console.error(error);
            alert("일정 저장에 실패했습니다.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleStart = async () => {
        setIsLoading(true);
        try {
            const response = await startSceneSchedule(scene.id);
            if (response.status === 200) {
                onUpdate(response.data);
                alert("선택이 시작되었습니다.");
            }
        } catch (error) {
            console.error(error);
            alert("시작 처리에 실패했습니다.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleEnd = async () => {
        setIsLoading(true);
        try {
            const response = await endSceneSchedule(scene.id);
            if (response.status === 200) {
                onUpdate(response.data);
                alert("선택이 종료되었습니다.");
            }
        } catch (error) {
            console.error(error);
            alert("종료 처리에 실패했습니다.");
        } finally {
            setIsLoading(false);
        }
    };

    const isActive = initialSchedule?.is_active;

    return (
        <div className="border rounded-lg p-4 m-2 bg-white shadow-sm w-full md:w-auto transition-all duration-200">
            <div
                className="flex justify-between items-center cursor-pointer select-none"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div className="flex items-center gap-2">
                    <h3 className="text-lg font-bold">{scene.name}</h3>
                    <span className={`px-2 py-0.5 rounded text-xs ${isActive ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"}`}>
                        {isActive ? "선택 가능" : "선택 불가"}
                    </span>
                </div>
                <div className="text-gray-500">
                    {isExpanded ? (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                        </svg>
                    )}
                </div>
            </div>

            {isExpanded && (
                <div className="mt-4 pt-4 border-t">
                    <div className="flex flex-col gap-2 mb-3">
                        <div className="flex gap-2 items-center">
                            <span className="text-sm w-16 text-gray-600">시작일시</span>
                            <DatePicker
                                selected={startAt}
                                onChange={(date) => setStartAt(date)}
                                showTimeSelect
                                dateFormat="yyyy-MM-dd HH:mm"
                                className="border rounded px-2 py-1 text-sm w-full"
                                placeholderText="선택 시작 시간"
                            />
                        </div>
                        <div className="flex gap-2 items-center">
                            <span className="text-sm w-16 text-gray-600">종료일시</span>
                            <DatePicker
                                selected={endAt}
                                onChange={(date) => setEndAt(date)}
                                showTimeSelect
                                dateFormat="yyyy-MM-dd HH:mm"
                                className="border rounded px-2 py-1 text-sm w-full"
                                placeholderText="선택 종료 시간"
                            />
                        </div>
                    </div>

                    <div className="flex gap-2 justify-end">
                        <div className="w-20">
                            <Button onClick={handleSave} disabled={isLoading} small={true} color="blue">저장</Button>
                        </div>
                        <div className="w-24">
                            <Button onClick={handleStart} disabled={isLoading} small={true} color="indigo">지금 시작</Button>
                        </div>
                        <div className="w-24">
                            <Button onClick={handleEnd} disabled={isLoading} small={true} color="red">지금 마감</Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SceneScheduleCard;
